import { render } from "./Connection.vue?vue&type=template&id=0bd71fb0&scoped=true"
import script from "./Connection.vue?vue&type=script&lang=js"
export * from "./Connection.vue?vue&type=script&lang=js"

import "./Connection.vue?vue&type=style&index=0&id=0bd71fb0&lang=scss&scoped=true"
import "./Connection.vue?vue&type=style&index=1&id=0bd71fb0&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd71fb0"]])

export default __exports__